import { ITransaction } from '@wot/typings';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../components/Table';
import TableRowItem from './TableRowItem';
import { ISorting } from '../EarningsTable';
import { BiSort } from 'react-icons/bi';

export default function TableContainer({ data, handleSort }: {
  data: ITransaction[],
  handleSort?: (key: ISorting) => void;
}) {
  return (
    <Table>
      <TableHeading>
        <TableRow>
          <TableHeadingCol
            onClick={() => handleSort && handleSort('createdAt')}
            label="Date"
            component={
              <div className="flex items-center">
                <p className="">Date</p>
                <BiSort className="text-sm" />
              </div>
            }
          />
          <TableHeadingCol label="TRANSACTION ID" />
          <TableHeadingCol label="NAME" />
          <TableHeadingCol label="EMAIL" />
          {/* <TableHeadingCol label="DESCRIPTION" /> */}
          <TableHeadingCol label="AMOUNT" />
          <TableHeadingCol label="MODE OF PAYMENT" />
          <TableHeadingCol label="STATUS" />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((transaction) => (
          <TableRow key={transaction._id}>
            <TableRowItem transaction={transaction} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
